import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react"; 
import { useNavigate } from "react-router-dom"; 

function CalendarView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "1",
      label: "Name of Dam",
      children: prodd?.damName ?? "N/A",
    },

    {
      key: "2",
      label: "Water Source",
      children: prodd?.damWaterSource ?? "N/A",
    },
    {
      key: "3",
      label: "Volume",
      children: prodd?.damVolume ?? "N/A",
    },
    {
      key: "4",
      label: "Estimated Households",
      children: prodd?.damEstBeneficiaries ?? "N/A",
    },
    {
      key: "6",
      label: "Start Date",
      children: (
        <div>
          {prodd?.damStartDate
            ? moment(prodd?.damStartDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "7",
      label: "End Date",
      children: (
        <div>
          {prodd?.damEndDate
            ? moment(prodd?.damEndDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
    {
      key: "8",
      label: "Time Frame",
      children: prodd?.damTimeFrame ?? "N/A",
    },
    {
      key: "8",
      label: "Acreage",
      children: prodd?.damAcreage ?? "N/A",
    },
    {
      key: "9",
      label: "Remarks",
      children: prodd?.damDesc ?? "N/A",
    },
    {
      key: "10",
      label: "Crops",
      children: prodd?.damCrops ?? "N/A",
    },
    {
      key: "10",
      label: "Water Abstraction",
      children: prodd?.waType ?? "N/A",
    },
    {
      key: "11",
      label: "Livestock Number",
      children: prodd?.damLivestockNo ?? "N/A",
    },
    {
      key: "12",
      label: "Height",
      children: prodd?.damHeight ?? "N/A",
    },
    {
      key: "13",
      label: "Classification",
      children: prodd?.damClassification ?? "N/A",
    },
    
  ];
  

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Calendar Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title=""
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
       
      </div>
    </Drawer>
  );
}

export default CalendarView;
